module.exports = __webpack_public_path__ + "img/ring_skip_0_1_0.b1260aec.png";